import React, {useEffect} from "react";
import PropTypes from 'prop-types';
import Form from 'components/Form';
import {withRouter} from "react-router";
import {DemandValidationKeys} from 'constants/DemandValidation';
import ValidationShema from "constants/ValidationShema";
import PapersGeneratorList from "components/complex/papersGenerator/PapersGeneratorList";
import PapersGeneratorService from "services/PapersGeneratorService";

function PapersGenerator(
    {
        match
    }) {
    const FORM_ID = DemandValidationKeys.PAPERS_GENERATOR;
    const id = match.params.id;

    useEffect(() => {
        PapersGeneratorService.getAvailablePapers(id);
        return () => {
            PapersGeneratorService.clearResources(PapersGeneratorService.PAPERS_GENERATOR_LIST_RESOURCE_ID);
        }
    }, [id])

    return (
        <Form
            initialValues={{}}
            validationSchema={ValidationShema.any()}
            id={FORM_ID}
        >{(formikProps) => (
            <PapersGeneratorList id={id}/>)}
        </Form>
    )
}

PapersGenerator.propTypes = {
    classes: PropTypes.any,
}

export default withRouter(PapersGenerator);